import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useConfig } from './use-config';
import { disconnectDatabaseConnection } from 'services/database-connection-service';

/**
 * Hook to disconnect (deactivate) a database connection
 */
export const useDisconnectDatabaseConnection = () => {
    const { configurationSettings } = useConfig();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (connectionId: string) => 
            disconnectDatabaseConnection(configurationSettings, connectionId),
        onSuccess: () => {
            // Invalidate the database connections list to refresh the data
            queryClient.invalidateQueries({ queryKey: ['listDatabaseConnections'] });
        },
    });
};

